/**
 * Created by mac on 2017/5/25.
 */
import Cookie from 'js-cookie'
import { urlAssets } from '../../api/url'
const user = {
  state: {
    userInfo: null,
    // 标识用户是否拥有登录权限
    authorization: Cookie.get('User-Token'),
    roles: null,
    isInitRouter: "false",
    homeLogo:'',
    nick: '',
    
    mcpath: [],
    isRcMcpath: true,
  },
  mutations: {
    SET_ISRCMCPATH: (state, is) => {
      state.isRcMcpath = is
    },
    SET_MCPATH: (state, arr) => {
      state.mcpath = arr
    },
    SET_NICK: (state, str) => {
      state.nick = str
    },
    SET_INITROUTER: (state, str) => {
      state.isInitRouter = str
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_USERROLE: (state, roles) => {
      state.roles = roles
    },
    SET_AUTHORIZATION: (state, boo) => {
      state.authorization = boo
    },
    SET_HOMELOGO: (state, logo) => {
      /*console.log("步骤二")
      console.log(logo);*/
      if(logo !== 'null' && logo !== ''){
        state.homeLogo = `${urlAssets.prefix}` + logo;
        //alert(state.homeLogo)
        //alert("wu"+state.homeLogo)
      }else{
        // state.homeLogo = `${urlAssets.prefix}tms-server-web/model/logo.png`;
        state.homeLogo = require('../../assets/logo.png')

      }
    }
  },
  actions: {
    
    setIsRcMcpath({commit},is){
      commit('SET_ISRCMCPATH',is)
    },
    setMCPath({commit},arr){
      commit('SET_MCPATH',arr)
    },
    setNick({commit},nick){
      /*console.log("步骤一")
      console.log(logo)*/
      commit('SET_NICK',nick)
    },
    setHomeLogo({commit},logo){
      /*console.log("步骤一")
      console.log(logo)*/
      commit('SET_HOMELOGO',logo)
    },
    setInitRouter({commit}, str) {
      commit('SET_INITROUTER',str)
    },
    setUserRoles({ commit }, roles) {
      commit('SET_USERROLE', roles)
    },
    setUserInfo({ commit }, userInfo) {
      commit('SET_USERINFO', userInfo)
    },
    setAuthorization ({ commit }, boo) {
      commit('SET_AUTHORIZATION', boo)
    },
    loginByUserName({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        // loginByEmail(email, userInfo.password).then(response => {
        //   const data = response.data;
        //   Cookies.set('Admin-Token', response.data.token);
        //   commit('SET_TOKEN', data.token);
        //   commit('SET_EMAIL', email);
        //   resolve();
        // }).catch(error => {
        //   reject(error);
        // });

      });
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js